// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"07455dc2","685":"bb91bb32","688":"07455dc2","727":"bb91bb32","905":"bb91bb32"}[chunkId] + ".chunk.css";
};